var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',[(_vm.welcoming)?_c('div',{staticClass:"welcome"}):_vm._e()]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }